import { useTranslation } from 'react-i18next';
import LockIcon from '@/lib/assets/lock.svg';
import WeezIcon from '@/lib/assets/weez.svg';
import styles from './PaymentFooter.module.scss';

const PaymentFooter = () => {
    const {t} = useTranslation();
    return (
        <div className={styles.footer}>
            <p>
                <LockIcon className={styles.footer_lock_icon} alt="lock" />
                {t('securePayment')}
            </p>
            <p>{t('secureProtocolInfo')}</p>
            <div className={styles.poweredby}>
                <WeezIcon alt="weezevent" />
                <p>{t('poweredBy')}</p>
            </div>
        </div>
    );
};

export default PaymentFooter;
